import type { CrmListObjectType } from "app/pages/sales-intelligence/domain/crm-integration/types/object-type";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { EntityIndustryTaxonomy } from "app/pages/sales-intelligence/domain/industry/types/taxonomy";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

export enum TopCompanyAssociatedListType {
    SavedSearch = 1,
    HubspotList,
    SalesforceList,
    OpportunityList,
    AssignedToMeList,
}

export interface ITopCompanyAssociatedList {
    id: string;
    name: string;
    assetType?: TopCompanyAssociatedListType;

    crmIntegrationType?: CrmIntegrationProvider;
    crmObjectType?: CrmListObjectType;
}

export interface ITopCompanyItem {
    favicon: string;
    companyName: string;
    domain: string;
    annualRevenue?: number | string;
    companyCountryCode?: number;
    /** @deprecated The legacy classification. Served only to accounts without the taxonomy opt-in (ADR-0013). */
    industry?: string;
    /** Present instead of `industry` for opted-in accounts — never alongside it (ADR-0013). */
    industryTaxonomy?: EntityIndustryTaxonomy;
    associatedList?: ITopCompanyAssociatedList;
    selectedContact?: ContactSearchEntry;
}
